import { Question } from '@playbooks/core/src/interfaces/ActionCard'

import getAnswer from './getAnswer'
import { useTranslation } from '../contexts/localization/Localization'

/**
 * Process '$...' replacements in the given text using the provided Action Card questions values.
 * @param text Text to process
 * @param translation Translator function
 * @param questionsWithCode Array of questions with codes to replace in the text
 * @param useBrackets useBrackets boolean, if the value must be is brackets
 * @returns Processed text
 */
export function processReplacements(text: string | null, questionsWithCode: Question[], useBrackets: boolean = true) {
  const translation = useTranslation.text

  questionsWithCode.forEach(question => {
    const res = getAnswer(question, translation, useBrackets)
    text = text?.replaceAll(`$${question.code}`, res) || null
  })

  return text
}
